var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-box"},[_c('ul',{staticClass:"steps-title"},_vm._l((_vm.stepsArr),function(title,index){return _c('li',{key:index,class:[
                { active: _vm.activeId == index },
                { accomplish: index < _vm.activeId },
                { disabled: index > _vm.activeId },
            ],on:{"click":function($event){return _vm.goBack(index)}}},[(index != 0)?_c('span',{staticClass:"triangle left-triangle"}):_vm._e(),_c('p',[_vm._v(_vm._s(title))]),(index != 3)?_c('span',{staticClass:"triangle right-triangle"}):_vm._e(),(index == 3)?_c('span',{staticClass:"square"}):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }